var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChange = function SvgChange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.186 1.06 2.133 6.236l5.053 5.174M2.984 6.234h11.791M23.05 20l4.825-4.94-4.825-4.942m4.013 4.942H15",
    stroke: "#7D80DA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
export { SvgChange as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAzMCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik03LjE4NiAxLjA2IDIuMTMzIDYuMjM2bDUuMDUzIDUuMTc0TTIuOTg0IDYuMjM0aDExLjc5MU0yMy4wNSAyMGw0LjgyNS00Ljk0LTQuODI1LTQuOTQyTTI3LjA2MyAxNS4wNkgxNSIgc3Ryb2tlPSIjN0Q4MERBIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K";